var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlatinum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPlatinum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.599807,432.612223 C194.62043,432.612223 193.788403,433.403866 193.788403,434.442968 C193.788403,434.788962 193.886452,435.085688 194.033247,435.333147 L189.382316,440.132834 C188.109902,438.054631 187.277875,434.987153 186.836934,432.958217 C187.522165,432.612223 188.011853,431.919675 188.011853,431.078204 C188.011853,429.940566 187.081778,429 185.955605,429 C184.829987,429 183.899357,429.940566 183.899357,431.078204 C183.899357,431.919675 184.389046,432.612223 185.074277,432.958217 C184.63389,434.987153 183.801309,438.054631 182.528341,440.132834 L177.877963,435.333147 C178.024759,435.085688 178.122808,434.788962 178.122808,434.442968 C178.122808,433.453134 177.339528,432.612223 176.311404,432.612223 C175.28328,432.612223 174.5,433.403866 174.5,434.442968 C174.5,435.432242 175.28328,436.273713 176.311404,436.273713 L179.640066,447.653446 C179.689367,447.851637 179.885464,448 180.129754,448 L191.830204,448 C192.026301,448 192.221844,447.851637 192.319892,447.653446 L195.599807,436.223885 C196.579184,436.223885 197.411765,435.432242 197.411765,434.39314 C197.362464,433.403866 196.579184,432.612223 195.599807,432.612223",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-See-less",
    transform: "translate(-174.000000, -429.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icPlatinum",
    fill: "#FFCE07",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlatinum);
export default __webpack_public_path__ + "static/media/icPlatinum.79fb6ef8fc2139357af3b34c9bde5469.svg";
export { ForwardRef as ReactComponent };